interface PrivacyNoticeProps {
  isOpen: boolean
  onDismiss: () => void
}

export function PrivacyNotice({ isOpen, onDismiss }: PrivacyNoticeProps) {
  if (!isOpen) {
    return null
  }

  return (
    <div className="dialog-backdrop" role="presentation">
      <section className="privacy-card" role="dialog" aria-modal="true" aria-labelledby="privacy-title">
        <p className="eyebrow">Privacy</p>
        <h2 id="privacy-title">Your data never leaves this device.</h2>
        <p>
          MarkView stores documents, saved screens, and preferences in on-device storage only.
          There are no accounts, no sync calls, and no analytics.
        </p>
        <button type="button" className="primary-button" onClick={onDismiss}>
          Continue offline
        </button>
      </section>
    </div>
  )
}
